<template>
    <!-- <div>  	   -->
    <b-form-group
        :label="field.label || labelId"
        :class="{
            'required-field': notRequired?false:this.field.isRequired,
        }"
        label-for="inputId"
    >
        <b-form-file
            :ref="`file-input ${field.label || labelId}`"
            v-model="model"
            v-validate="{
                required: notRequired?false:this.field.isRequired,
            }"
            input-id="identity"
            :placeholder="
                originalFileName || field.placeholder
            "
            drop-placeholder="Drop file here..."
            file-type="identityNew"
            :accept="field.fileTypes"
            :disabled="disabled || !identityInfoType || loading || (routeName!='edit-profile-upload-document' && cardType==null && country=='Pakistan')"
            :data-vv-name="field.label || labelId"
            :class="{
                'is-invalid': errors.has('ID document back scan copy'),
                'required-field': notRequired?false:this.field.isRequired,
            }"
            @input="uploadImage"
        ></b-form-file>
        <b-modal
            id="ver"
            fileType="this.fileType"
            ref="modal"
            :size="modalSize"
            title="Identity Document Back"
            :click-to-close="false"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            @close="onHidden"
            :hide-header-close="this.cropped"
        >
             <div 
                   v-if="fileType!=='application/pdf' && !verification"
                   @click="rotateImage"
                   class="custom-rotate"
                   >
				<img :src="require('../../assets/reset.png')" 
                 >
			</div>
            <cropper
                v-if="this.fileType!=='application/pdf' && !verification"
                ref="cropper"
                :src="image"
                class="upload-example-cropper"
            ></cropper>
            <div v-else-if="verification"> 
                <img 
                :style="{'display': !cancelDisable && verification && !afterVerification  ?'inline-block' : 'none' }"
                style="height: 30px !important;
                    position: absolute;
                    top: -1px;
                    left: 592px;"
                    @click="openGuideAfterFail"
                    :src="`${this.filesUrl}logo/circle-info.png`" 
                 >
                
                <p class="heading" 
                   :class="{'pass':cancelDisable,
                             'failed':okDisable
                   }"
                >
                {{ocrVerificationStatus}}
                </p>
                <div 
                :class="{'verification-modal-image-preview-container':this.filename,
                         'border-failed':this.okDisable,
                         'border-pass':this.cancelDisable
                }">
                    
                    <img v-if="filename" :src=imageUrl alt="no preview"/>
                </div>
                <div
                class="'ocr-messages-div'"
                style="margin: -12px 0px 0px 178px!important;"
                >
                    
                    <div 
                    v-for="(item,index) in ocrResult.frontEndMessages">
                        <div class="ocr-messages-icons">
                        <base-grid-status
                        :statusType="item['icon']"
                        :class="'mb-3'"
                        ></base-grid-status>   
                         </div>
                         <div class="ocr-messages">
                        {{ item.text }}
                        </div>
                    </div>
                </div>
            </div>
            <label v-else >
                Kindly note that Optical Character Recognition (OCR) is not supported on PDF document
            </label>
            <!-- <button v-on:click="rotateImage">Rotate Image</button> -->
            <template #modal-footer="{}">
                <b-button size="sm" variant="primary" 
                          :style="{'display':!okDisable ?'inline-block' : 'none' }"
                          @click="crop" :disabled="afterVerification || okDisable || (field.disAllowPDF && fileType=='application/pdf')">
                    continue
                </b-button>
                <b-button size="sm"
                          :class="{'cancel-btn':!afterVerification && !okDisable,
                                    'primary-btn':okDisable}"
                          :style="{'display': !cropped || cropped && okDisable && !afterVerification?'inline-block' : 'none' }"
                          class="custom-btn" @click="onHidden" :disabled="afterVerification || cancelDisable">
                   {{ !afterVerification && !okDisable ? 'Cancel' : 'Try uploading again !' }} 
                </b-button>
                
            </template>
        </b-modal>
    </b-form-group>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import TextField from './TextField'
import request from '@/utils/request'
import { mapGetters,mapMutations} from 'vuex'

export default {
    // End of Component > watch

    components: {
        Cropper,
    },
    extends: TextField, // End of Component > inject

    props: {
        formData :{},
        field: {
            type: Object,
            default() {
                return {
                    isRequired: true,
                    isLocked: true,
                    key: 'documentInfo.identityBack.fileName',
                    originalFileNameKey:
                        'documentInfo.identityBack.originalFileName',
                }
            },
            required: false,
        },
        disabled:{
            type:Boolean,
            required:false
        },
        notRequired:{
            type:Boolean,
            required:false
        },
        isOcrField:{
            type:Boolean,
            required:false
        },
    }, // End of Component > props
    data() {
        return {
            filename:"",
            ocrResult:"",
            image: '',
            selectedFileName: '',
            fileType: '',
            country: process.env.VUE_APP_COUNTRY,
            tempCountry: process.env.VUE_APP_COUNTRY_TEMP,
            filesUrl:process.env.VUE_APP_FILE_SERVICE_URL,
            verification:false,
            afterVerification:false,
            ocrVerificationStatus:"",
            cropped:false,
            modalSize:'lg',
            okDisable:false,
            cancelDisable:false
        }
    }, // End of Component > Data
    computed: {
        ...mapGetters(['loading','ocrStatusBack','ocrStatusFront','getField']),
        imageUrl(){
            return `${this.filesUrl}customers/${this.filename}`
        },
        routeName() {
            return this.$route.name
        },
        cardType() {
            return this.$store.getters.getField('identityInfo.cardType')
        },
        identityInfoType() {
            return this.$store.getters.getField('identityInfo.type')
        },
        originalFileName() {
            return this.$store.getters.getField(this.field.originalFileNameKey)
        },
        labelId() {
            return 'ID DOCUMENT BACK SCAN COPY'
        },
        idFrontFileName(){
            return this.getField('documentInfo.identity.fileName')
        },
        emiratesIdFileName(){
            return this.getField('documentInfo.fieldEmiratesID.fileName')
        }
    },
    watch: {
        ocrStatusBack: function (value){
          
          if(value && value.result){
             this.ocrVerificationStatus = "Your document has been verified"
             this.afterVerification = false
             this.ocrResult = value
             this.cancelDisable = true
            this.$forceUpdate()
             this.$store.commit('setValue', {
                                             key: 'ocrStatusBack',
                                             value: null,
                                         })
       
         }
         else if(value && value.result === false){
            this.ocrResult = value
             this.ocrVerificationStatus = "Document verification failed"
             this.afterVerification = false
             this.okDisable = true
             this.$forceUpdate()
             this.$store.commit('setValue', {
                                             key: 'ocrStatusBack',
                                             value: null,
                                         })
         }
     },
     cardType(value){
            let arr = ['passport','passportMRZ','license','brp','URDU','SMART','nicopNew','nicopOld','qrp','uaeOldResidentCard', 'uaeSmartResidentCard','']
            let temps = ['UAE','Qatar']
            let key = 'documentInfo.identityBack.fileName'
            if(temps.includes(this.tempCountry)){
               key = 'documentInfo.fieldEmiratesIDBack.fileName'
            }
            if(arr.includes(value) && this.field.key == key){
                this.onHidden()
            } 
        },
     idFrontFileName(value){
        let arr = ['license','brp','URDU','SMART','nicopNew','nicopOld','qrp','uaeOldResidentCard', 'uaeSmartResidentCard']
            let key = 'documentInfo.identityBack.fileName'
            if(arr.includes(this.cardType) && this.isOcrField && this.field.key == key){
                this.onHidden()
            } 
    },
    emiratesIdFileName(){
            let arr = ['qrp','uaeOldResidentCard', 'uaeSmartResidentCard']
            let key = 'documentInfo.fieldEmiratesIDBack.fileName'
            console.log("in  emiratesIdFileName")
            if(arr.includes(this.cardType) && this.isOcrField && this.field.key == key){
                this.onHidden()
            } 

    }

    },
    inject: {
        $validator: '$validator',
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {},
    beforeDestroy() {
        let arr = ['passport','passportMRZ',""]
        let temps = ['UAE','Qatar']
        let key = 'documentInfo.identityBack.fileName'
            if(temps.includes(this.tempCountry)){
               key = 'documentInfo.fieldEmiratesIDBack.fileName'
            }
            if(arr.includes(this.cardType) && this.field.key == key){
                this.onHidden()
            } 
   },
    methods: {
        ...mapMutations(['setValue']), 
        openGuideAfterFail(){
            this.setValue({
                                key: 'isShowGuide',
                                value: true,
                            })
            this.onHidden()
        },
        onHidden() {
            this.$refs[`file-input ${this.field.label || this.labelId}`].reset()
            // console.log('modal-hide-start')
            this.$refs.modal.hide()
            this.$store.commit('updateField', {
                key: this.field.key,
                value: null,
            })
            this.cropped = false
            this.verification = false 
            this.modalSize = 'lg'
            this.okDisable = false
            this.cancelDisable = false
            this.filename =''
            this.ocrResult = ''
            this.updateOriginalFileName(null)

            // console.log('modal-hide-finsih')
        },
        rotateImage() {
            var image = document.createElement('img')
            image.crossOrigin = 'anonymous'
            image.src = this.image
            image.onload = () => {
                var canvas = document.createElement('canvas')
                var ctx = canvas.getContext('2d')

                /**
                 * Rotating Image 90 degrees
                 */
                if (image.width > image.height) {
                    canvas.width = image.height
                    canvas.height = image.width
                    ctx.translate(image.height, image.width / image.height)
                } else {
                    canvas.height = image.width
                    canvas.width = image.height
                    ctx.translate(image.height, image.width / image.height)
                }
                ctx.rotate(Math.PI / 2)
                ctx.drawImage(image, 0, 0)

                // /**
                //  * Rotating Image 180 Degrees */
                // canvas.width = image.width;
                // canvas.height = image.height;
                // ctx.translate(canvas.width / 2,canvas.height / 2);
                // // Rotate the image and draw it on the canvas.
                // 	// (I am not showing the canvas on the webpage.
                // ctx.rotate(Math.PI);
                // ctx.drawImage(image, -image.width / 2, -image.height / 2);

                this.image = canvas.toDataURL()
            }
        },
        updateOriginalFileName(newValue) {
            // console.log('New Values: ' + newValue)
            // console.log('New Values: ' + this.field.originalFileNameKey)
            this.$store.commit('updateField', {
                key: this.field.originalFileNameKey,
                value: newValue,
            })
        },
        change({ coordinates, canvas }) {
            // console.log(coordinates, canvas)
        },
        crop() {
            if(!this.cropped){
            // console.log(this.$refs)
            // const { coordinates, canvas, } = this.$refs.cropper.getResult();
            if(this.fileType!=='application/pdf'){
                const result = this.$refs.cropper.getResult()
                this.image = result.canvas.toDataURL('image/jpeg')
            }
            // console.log(result)
            // this.coordinates = coordinates;
            // You able to do different manipulations at a canvas
            // but there we just get a cropped image, that can be used
            // as src for <img/> to preview result
            
            // Split the base64 string in data and contentType
            var block = this.image.split(';')
            // Get the content type of the image
            var contentType = block[0].split(':')[1] // In this case "image/gif"
            // get the real base64 content of the file
            var realData = block[1].split(',')[1] // In this case "R0lGODlhPQBEAPeoAJosM...."
            // Convert it to a blob to upload
            var blob = this.b64toBlob(realData, contentType)

            var file = new File([blob], this.selectedFileName)
            // console.log(file)
            // this.onFileInput(file)
            if(this.fileType!=='application/pdf'){
                this.fileCompressor(file)
            }
            else
            {
                this.encrypt(file)
            }
            
            let OcrRouteNames = ['self-registration-upload-document','deep-registration-upload-document','edit-profile-upload-document']
            if( !OcrRouteNames.includes(this.routeName) || this.fileType=='application/pdf'
                || !this.formData.documentValidation || this.customerType=='company' || !this.isOcrField 
               ) {
            this.$refs.modal.hide()
            }else{
                this.cropped = true
                this.modalSize = 'sm'
                this.ocrVerificationStatus =  "Verifying your document..."
                this.verification = true
                this.afterVerification = true
            }
        }else{
            this.$refs.modal.hide()
            this.cropped = false
            this.verification = false 
            this.modalSize = 'lg'
            this.cancelDisable = false
            this.okDisable = false
        }
        },
        uploadImage(file) {
            this.filename = ''
            this.ocrResult = ''
            if(file.type=='application/pdf')
            {
                this.modalSize='md'
            }
            // console.log('UploadImageType: ' + file.type)
            // Reference to the DOM input element
            // var input = event.target;
            // // Ensure that you have a file before attempting to read it
            if (file) {
                if (
                    file.type === 'image/jpeg' ||
                    file.type === 'image/jpg' ||
                    file.type === 'image/png' ||
                    file.type === 'application/pdf'
                ) {
                    // console.log('UploadImage: ' + file)
                    this.updateOriginalFileName(file.name)
                    this.selectedFileName = file.name
                    this.fileType = file.type
                    // console.log(
                    //     'selectedFileName: ' + this.selectedFileName,
                    //     this.fileType
                    // )
                    // create a new FileReader to read this image and convert to base64 format
                    var reader = new FileReader()
                    // Define a callback function to run, when FileReader finishes its job
                    reader.onload = (e) => {
                        // console.log(e)
                        // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                        // Read image as base64 and set to imageData
                        this.image = e.target.result
                        this.$refs.modal.show()
                    }
                    // Start the reader job - read file as a data url (base64 format)
                    reader.readAsDataURL(file)
                } else {
                    this.onHidden()
                    this.$store.commit('setError', 'File format not supported')
                }
            }
        },
        async onFileInput(file) {
            // console.log('File: ' + file)
            if (file) {
                this.$store.commit('setLoading', true)
                try {
                    const formData = new FormData()

                    formData.append('type', 'identity')
                    formData.append('file', file, file.name)

                    const headers = {
                        'Content-Type': 'multipart/form-data',
                    }
                    const { data } = await request.post(
                        'files/encrypt',
                        formData,
                        {
                            headers,
                        }
                    )

                    // console.log('FileName: ' + data.data.fileName)
                    // console.log('FileName: ' + file.name)
                    setTimeout(() => {
                        this.$store.commit('updateField', {
                            key: this.field.key,
                            value: data.data.fileName,
                        })
                        this.filename = data.data.fileName
                        this.$emit('input', data.data.fileName)
                        this.updateOriginalFileName(file.name)
                        this.$store.commit('setLoading', false)
                    }, 3000)
                } catch (error) {
                    // console.log(error)
                    this.$store.commit('setLoading', false)
                }

                if(!this.formData.documentValidation)
                {
                    this.$store.commit('setLoading', false)
                }            }

        },
        encrypt(input) {
            // console.log(input)
            var file = input
            var reader = new FileReader()
            reader.onload = () => {
                // var key = process.env.VUE_APP_CRYPTO_SECERT_KEY
                var wordArray = this.CryptoJS.lib.WordArray.create(
                    reader.result
                ) // Convert: ArrayBuffer -> WordArray
                var encrypted = this.$encrypt(wordArray,false)
                var fileEnc = new Blob([encrypted]) // Create blob from string
                var filename = file.name + '.enc'
                const myFile = new File([fileEnc], filename, {
                    type: fileEnc.type,
                })

                this.onFileInput(myFile)
            }
            reader.readAsArrayBuffer(file)
            // console.log(file)
        },
        fileCompressor(input) {
            var file = input

            console.log('File Size', file.size)

            if (file.size >= 2097152) {
                console.log('1 MB Image')

                var readerImage = new FileReader()
                readerImage.readAsDataURL(file)

                readerImage.onload = (event) => {
                    const imgElement = document.createElement('img')
                    imgElement.src = event.target.result
                    // document.querySelector("#input").src = event.target.result;
                    console.log('imgElement.src')
                    console.log('Input', input)
                    imgElement.onload = (e) => {
                        const canvas = document.createElement('canvas')
                        const MAX_WIDTH = 600

                        const scaleSize = MAX_WIDTH / e.target.width
                        canvas.width = MAX_WIDTH
                        canvas.height = e.target.height * scaleSize

                        const ctx = canvas.getContext('2d')

                        ctx.drawImage(
                            e.target,
                            0,
                            0,
                            canvas.width,
                            canvas.height
                        )

                        const srcEncoded = ctx.canvas.toDataURL(
                            e.target,
                            'image/jpeg'
                        )

                        console.log('srcEncoded', srcEncoded)
                        // file = dataURLtoFile([srcEncoded] , file.name , file.type  )
                        var arr = srcEncoded.split(','),
                            mime = arr[0].match(/:(.*?);/)[1],
                            bstr = atob(arr[1]),
                            n = bstr.length,
                            u8arr = new Uint8Array(n)

                        while (n--) {
                            u8arr[n] = bstr.charCodeAt(n)
                        }

                        const fileConverted = new File([u8arr], file.name, {
                            type: mime,
                        })
                        console.log('FIle Converted', fileConverted)

                        this.encrypt(fileConverted)
                    }
                }
            } else {
                console.log('Image Below 1 mb')
                this.encrypt(file)
            }
        },
        b64toBlob(b64Data, contentType, sliceSize) {
            contentType = contentType || ''
            sliceSize = sliceSize || 512

            var byteCharacters = atob(b64Data)
            var byteArrays = []

            for (
                var offset = 0;
                offset < byteCharacters.length;
                offset += sliceSize
            ) {
                var slice = byteCharacters.slice(offset, offset + sliceSize)

                var byteNumbers = new Array(slice.length)
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i)
                }

                var byteArray = new Uint8Array(byteNumbers)

                byteArrays.push(byteArray)
            }

            var blob = new Blob(byteArrays, { type: contentType })
            return blob
        },
    }, // End of Component > mounted
}
</script>

<style>
.upload-example-cropper {
    border: solid 1px #eee;
    height: 350px;
    width: 100%;
}

.custom-rotate{
    position:absolute;
    z-index: 1;
    width: 50px;
    height: 50px;
}
</style>
